<p-dialog
  [header]="title"
  [visible]="isVisible"
  [modal]="true"
  [closable]="canCancel && !isLoading"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '40rem', maxWidth: '90vw' }"
  (onHide)="onDialogHide()"
>
  <ng-content />

  <ng-template #footer>
    @if (canCancel) {
      <p-button
        [label]="cancelBtnText"
        severity="contrast"
        variant="text"
        (onClick)="onCancelClick()"
        [disabled]="isLoading"
      />
    }
    @if (canConfirm) {
      <p-button
        [label]="confirmBtnText"
        [severity]="confirmBtnSeverity"
        [loading]="isLoading"
        (onClick)="onConfirmClick()"
      />
    }
  </ng-template>
</p-dialog>
